// extracted by mini-css-extract-plugin
export default {"card":"ConnectAccountCard-module__card_AtXq2","mobile-ui":"mobile-ui","icon":"ConnectAccountCard-module__icon_cGi1V","label":"ConnectAccountCard-module__label_LFUEl"};